module.exports = __webpack_public_path__ + "media/images/orion_pictos/white-map-pin-817ee55456faa1ccb4597ff0e822bba3.svg";